import { createContext } from 'react';

const CommonContext = createContext();

export default CommonContext;

export const YesNoOptions = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
];

export const agGridConstants = {
    columnFilterTypes: {
        number: 'agNumberColumnFilter', // A Number Filter for number comparisons.
        text: 'agTextColumnFilter', // A Text Filter for string comparisons.
        date: 'agDateColumnFilter', // A Date Filter for date comparisons.
        set: 'agSetColumnFilter', // A Set Filter, influenced by how filters work in Microsoft Excel.This is an ag- Grid - Enterprise feature.
    },
};

export const ApplicationPermissions = {
    applicationusercompliance_create: 'applicationusercompliance.create',
    applicationusercompliance_edit: 'applicationusercompliance.edit',
    applicationusercompliance_delete: 'applicationusercompliance.delete',
    applicationusercompliance_view: 'applicationusercompliance.view',

    billing_create: 'billing.create',
    billing_edit: 'billing.edit',
    billing_delete: 'billing.delete',
    billing_view: 'billing.view',
    billing_void: 'billing.void',
    billingissues_view: 'billingissues.view',

    billingrate_create: 'billingrate.create',
    billingrate_edit: 'billingrate.edit',
    billingrate_delete: 'billingrate.delete',
    billingrate_view: 'billingrate.view',

    billing_review_view: 'billing_review.view',
    billing_review_accept: 'billing_review.accept',
    billing_review_reject: 'billing_review.reject',
    billing_review_invoice: 'billing_review.invoice',
    billing_tscontract_update: 'timesheet_contract.update',

    chargetype_create: 'chargetype.create',
    chargetype_edit: 'chargetype.edit',
    chargetype_delete: 'chargetype.delete',
    chargetype_view: 'chargetype.view',

    company_create: 'company.create',
    company_edit: 'company.edit',
    company_delete: 'company.delete',
    company_view: 'company.view',

    compliancetype_create: 'compliancetype.create',
    compliancetype_edit: 'compliancetype.edit',
    compliancetype_delete: 'compliancetype.delete',
    compliancetype_view: 'compliancetype.view',

    location_create: 'location.create',
    location_edit: 'location.edit',
    location_delete: 'location.delete',
    location_view: 'location.view',

    locationcontact_create: 'location_contact.create',
    locationcontact_edit: 'location_contact.edit',
    // locationcontact_delete: 'location.delete',
    locationcontact_view: 'location_contact.view',

    contactactivity_create: 'contactactivity.create',
    contactactivity_edit: 'contactactivity.edit',
    contactactivity_delete: 'contactactivity.delete',
    contactactivity_view: 'contactactivity.view',

    contract_create: 'contract.create',
    contract_edit: 'contract.edit',
    contract_delete: 'contract.delete',
    contract_view: 'contract.view',

    contractcompliance_create: 'contractcompliance.create',
    contractcompliance_edit: 'contractcompliance.edit',
    contractcompliance_delete: 'contractcompliance.delete',
    contractcompliance_view: 'contractcompliance.view',

    contractTemplate_create: 'contract_template.create',
    contractTemplate_edit: 'contract_template.edit',
    contractTemplate_view: 'contract_template.view',
    contractTemplate_delete: 'contract_template.delete',

    customer_create: 'customer.create',
    customer_edit: 'customer.edit',
    customer_contacts_edit: 'customer.contacts_edit',
    customer_delete: 'customer.delete',
    customer_view: 'customer.view',

    dispatch_create: 'dispatch.create',
    dispatch_edit: 'dispatch.edit',
    dispatch_delete: 'dispatch.delete',

    dispatch_view: 'dispatch.view',
    dispatch_view_all: 'dispatch.view_all',

    dispatch_review_view: 'dispatch_review.view',
    dipsatch_review_accept: 'dipsatch_review.accept',
    dispatch_review_reject: 'dispatch_review.reject',

    equipment_create: 'equipment.create',
    equipment_edit: 'equipment.edit',
    equipment_delete: 'equipment.delete',
    equipment_view: 'equipment.view',

    equipmentcompliance_create: 'equipmentcompliance.create',
    equipmentcompliance_edit: 'equipmentcompliance.edit',
    equipmentcompliance_delete: 'equipmentcompliance.delete',
    equipmentcompliance_view: 'equipmentcompliance.view',

    equipmentstatus_create: 'equipmentstatus.create',
    equipmentstatus_edit: 'equipmentstatus.edit',
    equipmentstatus_delete: 'equipmentstatus.delete',
    equipmentstatus_view: 'equipmentstatus.view',

    equipmenttype_create: 'equipmenttype.create',
    equipmenttype_edit: 'equipmenttype.edit',
    equipmenttype_delete: 'equipmenttype.delete',
    equipmenttype_view: 'equipmenttype.view',

    employee_create: 'employee.create',
    employee_edit: 'employee.edit',

    employee_delete: 'employee.delete',
    employee_view: 'employee.view',
    employee_onboarding: 'employee.onboard',
    employee_add: 'employee.add',
    employee_view_history: 'employee.history',

    employee_pay_view: 'employee_pay.view',

    employee_routing_address_edit: 'employee_routing_address.edit',
    employee_home_address_edit: 'employee_home_address.edit',
    employee_username_edit: 'employee_username.edit',
    employee_group_edit: 'employee_groups.edit',
    employee_name_edit: 'employee_name.edit',
    employee_payroll_company_edit: 'employee_payroll_company.edit',
    employee_dispatch_company_edit: 'employee_dispatch_company.edit',
    employee_number_edit: 'employee_number.edit',
    employee_phone_edit: 'employee_phone.edit',
    employee_notifications_edit: 'employee_notifications.edit',
    employee_importupdates_edit: 'employee_importupdates.edit',
    employee_accountstatus_edit: 'employee_accountstatus.edit',
    employee_password_edit: 'employee_password.edit',
    employee_exclude_dispatch: 'employee_exclude_dispatch.edit',

    employee_restriction_view: 'employee_restriction.view',
    employee_restriction_create: 'employee_restriction.create',
    employee_restriction_edit: 'employee_restriction.edit',
    employee_restriction_delete: 'employee_restriction.delete',

    group_create: 'group.create',
    group_edit: 'group.edit',
    group_delete: 'group.delete',
    group_view: 'group.view',

    job_create: 'job.create',
    job_edit: 'job.edit',
    job_delete: 'job.delete',
    job_view: 'job.view',

    payroll_create: 'payroll.create',
    payroll_edit: 'payroll.edit',
    payroll_delete: 'payroll.delete',
    payroll_view: 'payroll.view',

    payroll_review_view: 'payroll_review.view',
    payroll_review_accept: 'payroll_review.accept',
    payroll_review_reject: 'payroll_review.reject',
    payroll_review_export: 'payroll_review.export',

    self_dispatch_timesheet_create: 'selfdispatchtimesheet.create',
    self_dispatch_timesheet_view: 'selfdispatchtimesheet.view',
    nonFlagging_timesheet_view: 'nonflaggingtimesheet.view',
    nonFlagging_timesheet_create: 'nonflaggingtimesheet.create',

    timesheet_create: 'timesheet.create',
    timesheet_edit: 'timesheet.edit',
    timesheet_delete: 'timesheet.delete',
    timesheet_export: 'timesheet.export',
    timesheet_view: 'timesheet.view',
    timesheet_accept: 'timesheet.accept',
    nf_timesheet_reject: 'timesheet.reject',
    flagging_timesheet_reject: 'flagging_timesheet.reject',
    timesheet_dashboard: 'timesheet_dashboard.view',

    quickBooksInventoryItem_view: 'quickBooksInventoryItem.view',
    quickBooksInventoryItem_create: 'quickBooksInventoryItem.create',
    quickBooksInventoryItem_edit: 'quickBooksInventoryItem.edit',
    quickBooksInventoryItem_delete: 'quickBooksInventoryItem.delete',

    countyGroup_view: 'county_group.view',
    countyGroup_create: 'county_group.create',
    countyGroup_edit: 'county_group.edit',
    countyGroup_delete: 'county_group.delete',

    tenant_edit: 'tenant.edit',
    impersonation_toggle: 'impersonation.toggle',
    company_code_edit: 'company_code.edit',
};

export const Weekdays = [
    {
        id: 0,
        name: 'Sunday',
        abbreviation: 'Sun',
        abbreviationShort: 'S',
    },
    {
        id: 1,
        name: 'Monday',
        abbreviation: 'Mon',
        abbreviationShort: 'M',
    },
    {
        id: 2,
        name: 'Tuesday',
        abbreviation: 'Tue',
        abbreviationShort: 'T',
    },
    {
        id: 3,
        name: 'Wednesday',
        abbreviation: 'Wed',
        abbreviationShort: 'W',
    },
    {
        id: 4,
        name: 'Thursday',
        abbreviation: 'Thu',
        abbreviationShort: 'R',
    },
    {
        id: 5,
        name: 'Friday',
        abbreviation: 'Fri',
        abbreviationShort: 'F',
    },
    {
        id: 6,
        name: 'Saturday',
        abbreviation: 'Sat',
        abbreviationShort: 'S',
    },
];

export const SupportedFileExtensions = {
    image: ['.gif', '.jpg', '.jpeg', '.png', '.heic', '.webp'],
    document: ['.xlsx', '.xls', '.pdf', '.txt', '.doc', '.docx'],
    xml: ['.xml'],
};

export const SiteRoles = {
    Administrator: '6f176015-2b18-4d7a-896a-aa97c498ea66',
    RegionalSupport: '4488e0d6-0e54-4079-8b15-39195c23188e',
};

export const ServiceResponseResult = {
    Ok: 0,
    Error: 1,
    OkWithErrors: 2,
};

export const TimesheetReviewType = {
    Client: 1,
    Employee: 2,
};

export const Months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const MonthsShort = [
    'Jan',
    'Feb',
    'Ma',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

// 2022-08-11 - M. Nicol
// Used in conjunction with Util.js > l10n to get localized strings.
// Note: Strings are part of CommonContext Provider definition in Layout.js.
// Accessible through CommonContext component itself or this.context as defined
// by "static contextType = CommonContext;" in most components.
// Should be kept in sync with API.
export const LocalizationKeys = {
    billing: 'Billing',
    crewLead: 'CrewLead',
};
